var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'pdt-anchor-section': true
  }},[_c('div',{staticClass:"pdt-anchor",staticStyle:{"height":"0px","overflow":"hidden"},attrs:{"id":_vm.name,"name":_vm.name,"title":_vm.title,"short-title":_vm.shortTitle || _vm.title}},[_c('a',{attrs:{"href":("#" + _vm.name)}},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }